@if (design) {
  <ng-container [ngTemplateOutlet]="DESIGN_4"></ng-container>
}
<ng-template #DESIGN_4>
  <div class="page-content donation-details" fxLayout="column">
    <div fxLayout="column" fxLayout.gt-sm="row" class="progress-wrapper">
      <app-create-progress fxFlex [step]="flowStep" [flowConfiguration]="flowConfiguration" />
    </div>
    <div class="donation-info step-content" fxLayoutAlign="center center" fxLayoutAlign.lt-md="center start" fxFlex>
      <div fxLayout="column" fxLayoutAlign="center center">
        <h1 class="main">Add the items that you would like us to pick up</h1>
        <h3 class="main">
          Please type the name of your item in the search bar below. Select the correct option from the list of items and enter the
          quantity.
        </h3>
        <div class="search-input">
          <input [placeholder]="'Add Item'" #inputElement matInput type="text" readonly (click)="openAddItemPopup()" />
          <mat-icon>search</mat-icon>
        </div>
        @if (lead.items?.length > 0 || lead.specification.disassembly > 0) {
          <div class="added-items">
            <h3>Your items ({{ lead.items?.length }})</h3>
            @for (i of lead.aggregatedItems; track i) {
              <div class="item" fxLayout="row" fxLayoutGap="25px" fxLayoutGap.lt-md="5px" fxLayoutAlign="center center">
                <div class="image no-mobile" fxFlex="50px" fxLayoutAlign="space-around center">
                  <img
                    class="icon"
                    [ngClass]="{
                      'icon-url': i.item.icon_url,
                    }"
                    [src]="i.item.type === 'Item' && i.item.icon_url ? i.item.icon_url : 'assets/icons-v2/custom-item.svg'"
                    [alt]="i.item.name"
                  />
                </div>
                <div class="title" (click)="openInfoDialog(i)" fxLayout="column" fxLayoutGap="4px">
                  <h3>
                    <img class="no-desktop info-icon" src="/assets/images/info.svg" />
                    {{ i.item.name }}
                  </h3>
                  <p>{{ sizeDescriptions[i.item.size] }}</p>
                  @if (i.item.type === 'Item') {
                    <div fxLayout="row" fxLayoutGap="10px">
                      <span class="read-more">read more</span>
                    </div>
                  }
                </div>
                <div class="counter-controls" fxLayout="row" fxLayoutAlign="space-between">
                  <div class="counter-btn" (click)="removeItem(i)" [ngClass]="{ remove: i.count === 1 }">
                    <mat-icon>{{ i.count > 1 ? 'remove' : 'delete_forever' }}</mat-icon>
                  </div>
                  <input type="tel" [(ngModel)]="i.count" (input)="handleQuantityChangeThroughInput(i, $event)" />
                  <div class="counter-btn" (click)="addItem(i)">
                    <mat-icon>add</mat-icon>
                  </div>
                </div>
              </div>
            }

            @if (lead?.specification?.disassembly > 0) {
              <div class="services-wrapper">
                <h3>Services</h3>
                <div class="item" fxLayout="row" fxLayoutGap="25px" fxLayoutGap.lt-md="5px" fxLayoutAlign="center center">
                  <div class="image no-mobile" fxFlex="50px" fxLayoutAlign="space-around center">
                    <img class="icon" src="{{ 'assets/icons-v2/disassembly.svg' }}" alt="disassembly" />
                  </div>
                  <div class="title" fxLayout="column" fxLayoutGap="4px">
                    <h3>
                      <img class="no-desktop info-icon" src="/assets/images/info.svg" />
                      Disassembly
                    </h3>
                    <p>Items requiring tools to disassemble</p>
                    <div fxLayout="row" fxLayoutGap="10px">
                      <span class="read-more">read more</span>
                    </div>
                  </div>
                  <div class="counter-controls" fxLayout="row" fxLayoutAlign="space-between">
                    <div
                      class="counter-btn"
                      (click)="removeDisassembly()"
                      [ngClass]="{ disabled: lead?.specification.disassembly === 0, remove: lead?.specification.disassembly < 2 }"
                    >
                      <mat-icon>{{ lead?.specification.disassembly > 1 ? 'remove' : 'delete_forever' }}</mat-icon>
                    </div>
                    <input type="tel" [(ngModel)]="lead?.specification.disassembly" />
                    <div class="counter-btn" (click)="addDisassembly()">
                      <mat-icon>add</mat-icon>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <app-page-footer
      [hasBack]="hasBack"
      (onBack)="back()"
      (onSubmit)="saveLead()"
      [updateCartInProgress]="updateCartInProgress"
    ></app-page-footer>
  </div>
</ng-template>
